import type { FaireProductEntity } from "../../entity_types/product";

export const p_qvuhxm2tj9: FaireProductEntity = {
  token: "p_qvuhxm2tj9",
  type: "product",
  name: "Margarita / Mezcal Tasting Glasses - Tamarind",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/1ce6a6255fc214ff01ceaa48a8868a1bc6101fb229b51f01acab85f8389f20a1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/82dbdf4c93f650e9721d7511a8d3e558ce432b357cff2c67c1236955c57b7fd2.jpeg",
    "https://cdn.faire.com/fastly/588318ae7de0712b1e12b82068e333d685acfe73ab1c1168d9db8fc90b2fb681.jpeg",
    "https://cdn.faire.com/fastly/be09374253438deb11c4ae04950e803125777f4fb56169009a5768b8c96f884d.jpeg",
    "https://cdn.faire.com/fastly/899871f5147615191e12e64dac0e46ac0a6ad17d0a926d4d4093874cf1f6b073.jpeg",
    "https://cdn.faire.com/fastly/cfd45675446659420460923cb49a6388c75b6db1b791499a044f491968fba360.jpeg",
    "https://cdn.faire.com/fastly/7947e19d63e842b833c00c3a81fdfe587a7e745d8406b398cfa98fae85aea8cb.jpeg",
    "https://cdn.faire.com/fastly/35d25f4403f10013e551dc2f1e0d9d4dd79bd9a54c349352be0f9de961f0d900.jpeg",
  ],
  priceDollars: 10,
  description:
    "**Packaged in sets of 2 as shown; sold as 8 single glasses in a master (4 boxes of 2 glasses)**\n\nIntroducing our Handblown Mexican Glasses in Tamarind - the perfect match for simple, understated, and no-fuss drinks. Sustainably handcrafted by our talented glassblowing artisans in Jalisco, Mexico, each glass is meticulously shaped while molten hot, preserving its distinctive character. Available in sets of 4 for both short and highball sizes, because great drinks are meant to be enjoyed together. Elevate your drinking experience with these exquisite handblown glasses. Cheers to sustainability and craftsmanship!\n\nBe sure to check out our entire Tamarind Glassware Collection, including Highball Glasses, Short DOF Glasses, Shooter Glasses, and a matching Pitcher! \n\nCare: Dishwasher safe - Susceptible to breakage with extreme temperature changes. \n\nCapacity:\n400ml / 14 oz \n\nDimensions:\nEach Glass - 3.25'' tall x 4.75'' diameter",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:13.732Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
